import { InjectionToken } from '@angular/core';
import AWSAppSyncClient from 'aws-appsync';

export interface CoreServiceConfig {
  production: boolean;
  systemsTypes: ('aws' | 'firebase')[],
  firebaseConfig: {
    apiKey: string;
    appId: string;
    authDomain: string;
    databaseURL: string;
    locationId: string;
    messagingSenderId: string;
    projectId: string;
    storageBucket: string;
    measurementId: string;
  },
  timezone: {
    url: string;
    apiKey: string;
  },
  weather: {
    url: string,
    apiKeys: string[],
  },
  aws: {
    appsync: {
        default: {
            url: string;
            region: string;
            desc: string;
        };
        list: {
            url: string;
            region: string;
            desc: string;
        }[];
    };
    clientGen: (opt: any) => AWSAppSyncClient<any>;
  }
}

export const CORE_SERVICES_CONFIG = new InjectionToken<CoreServiceConfig>('CORE_SERVICES_CONFIG');
